exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".login-form {\r\n    margin-top: 80px;\r\n}\r\n.fa-user-circle {\r\n    font-size: 130px;\r\n    font-style: inherit;\r\n    margin-right: 80px;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Apache24/htdocs/ostimar/frontend/src/app/auth/signin/signin.component.css
// module id = ../../../../../src/app/auth/signin/signin.component.css
// module chunks = main